import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { checkValidity } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Components
import Privacy from '../Common/Privacy';
import { config } from '../../config';

const OAuth = observer(class OAuth extends React.Component {
  constructor() {
    super();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.complete = this.complete.bind(this);
    this.checkIntegration = this.checkIntegration.bind(this);
  }

  componentWillMount() {
    this.state = {
      integrationSid: this.props.integrationSid,
      showAuthBtn: false
    }

    this.props.store.SettingsStore.getIntegration(this.props.integrationSid, this.checkIntegration);
  }

  checkIntegration() {
    // Check to see if the Authenticate button should be shown
    const { integration } = this.props.store.SettingsStore

    // Show d2l authenticate button
    if(
      integration &&
      integration.systemName &&
      integration.systemName.toLowerCase() === 'desire2learn' &&
      integration.oAuthClientId &&
      integration.oAuthClientSecret &&
      integration.oAuthAuthUri
    ) {
      this.setState({
        showAuthBtn: true
      });
    }

    // Show Canvas authenticate button
    if(
      integration &&
      integration.systemName &&
      integration.systemName.toLowerCase() === 'canvas' &&
      integration.oAuthClientId &&
      integration.oAuthClientSecret &&
      integration.oAuthAuthUri
    ) {
      this.setState({
        showAuthBtn: true
      });
    }
  }

  componentWillUnmount() {
    this.props.store.SettingsStore.integration = {};
  }

  handleInput(name, e) {
    const data = {
      [name]: e.target.value
    };

    this.props.store.SettingsStore.updateIntegrationData(data);
  }

  handleSubmit() {
    this.props.store.SettingsStore.updateIntegration(
      this.state.integrationSid, this.complete
    );
  }

  complete() {
    const { integration } = this.props.store.SettingsStore

    if(
      integration &&
      (
        integration.systemName.toLowerCase() === 'desire2learn' ||
        integration.systemName.toLowerCase() === 'canvas'
      )
    ) {
      this.setState({
        showAuthBtn: true
      });
    }

    this.props.complete();
  }

  render() {
    const { translation } = this.props;
    const { SettingsStore } = this.props.store;
    const { integration } = this.props.store.SettingsStore;
    let systemName = '';

    if(integration && integration.systemName) {
      systemName = integration.systemName.toLowerCase();
    }

    return (
      <div className="drawer__content">
        <header className="drawer__header">
          <div className="wrap">
            <h1 className="drawer__title">{translation.heading} {integration.name}</h1>
          </div>
        </header>

        <div className="wrap block-form">
          {SettingsStore.integration.sid &&
            <form className="panel" onSubmit={(e) => checkValidity(e, this.handleSubmit)} noValidate>
              <div className="panel__body">
                {/* App key/secret */}
                <fieldset className="form-section">
                  <h4 className="form-heading">{translation.lti_settings}</h4>

                  <ul className="fields">
                    <li>
                      <label>{translation.launch_url}</label>
                      <span className="faux-input">
                        {config.ltiUrl}/v1/auth/lti
                      </span>
                    </li>
                    <li>
                      <label>{translation.access_key}</label>
                      <span className="faux-input">{integration.accessKey}</span>
                    </li>
                    <li>
                      <label>{translation.secret}</label>

                      <Privacy
                        className="faux-input"
                        show={translation.reveal}
                        hide={translation.hide}
                        private={integration.secret}
                        {...this.props}
                      />
                    </li>
                  </ul>
                </fieldset>

                {/* OAuth data */}
                <fieldset className="form-section">
                  <img
                    className="form-heading-img"
                    src={`./static/img/lms/${systemName}.png`}
                    width="200"
                    alt={`${systemName} logo`}
                  />

                  {systemName === 'blackboard' &&
                    <span className="yes-results success">System connected</span>
                  }

                  <div>
                    <ul className="fields">
                      {/*
                        These fields aren’t used by all integration Types,
                        so we need to check the system type
                      */}

                      {systemName !== 'desire2learn' && systemName !== 'blackboard' && systemName !== 'moodle' &&
                        <li>
                          <label htmlFor="sync-auth">
                            {translation.authentication_flow}
                          </label>

                          <label className="select">
                            <select
                              id="sync-auth"
                              defaultValue={integration.useAuthenticationFlow}
                              onChange={(e) => {this.handleInput('useAuthenticationFlow', e)}}
                            >
                              <option value="">{translation.auth.none}</option>
                              <option value="OAuth2">{translation.auth.oauth}</option>
                            </select>
                          </label>
                        </li>
                      }

                      {systemName === 'desire2learn' &&
                        <li>
                          <label>{translation.trusted_url}</label>
                          <span className="faux-input">
                            {config.ltiUrl}/v1/auth/d2l/{this.props.integrationSid}
                          </span>
                        </li>
                      }

                      {systemName !== 'blackboard' && systemName !== 'moodle' &&
                        <li>
                          <label className="lbl-required" htmlFor="client-id">
                            {translation[systemName].client_id}
                          </label>

                          <input
                            id="client-id"
                            type="text"
                            defaultValue={integration.oAuthClientId}
                            onChange={(e) => {this.handleInput('oAuthClientId', e)}}
                            required
                            aria-required="true"
                          />
                        </li>
                      }

                      {systemName !== 'blackboard' &&
                        <li>
                          <label className="lbl-required" htmlFor="client-secret">
                            {translation[systemName].client_secret}
                          </label>

                          <input
                            id="client-secret"
                            type="text"
                            defaultValue={integration.oAuthClientSecret}
                            onChange={(e) => {this.handleInput('oAuthClientSecret', e)}}
                            required
                            aria-required="true"
                          />
                        </li>
                      }

                      {systemName !== 'blackboard' && systemName !== 'moodle' &&
                        <li>
                          <label className="lbl-required" htmlFor="client-auth-uri">
                            {translation[systemName].auth_uri}
                          </label>

                          <input
                            id="client-auth-uri"
                            type="url"
                            defaultValue={integration.oAuthAuthUri}
                            onChange={(e) => {this.handleInput('oAuthAuthUri', e)}}
                            required
                            aria-required="true"
                          />
                        </li>
                      }

                      {systemName === 'canvas' &&
                        <li>
                          <label className="lbl-required" htmlFor="client-grant">
                            {translation[systemName].grant_type}
                          </label>

                          <input
                            id="client-grant"
                            type="text"
                            defaultValue={integration.oAuthGrantType}
                            onChange={(e) => {this.handleInput('oAuthGrantType', e)}}
                            required
                            aria-required="true"
                          />
                        </li>
                      }

                      {systemName === 'canvas' &&
                        <li>
                          <label className="lbl-required" htmlFor="client-purpose">
                            {translation[systemName].auth_purpose}
                          </label>

                          <input
                            id="client-purpose"
                            type="text"
                            defaultValue={integration.oAuthPurpose}
                            onChange={(e) => {this.handleInput('oAuthPurpose', e)}}
                            required
                            aria-required="true"
                          />
                        </li>
                      }

                      {systemName === 'canvas' &&
                        <li>
                          <label className="lbl-required" htmlFor="client-redirect">
                            {translation[systemName].redirect_uri}
                          </label>

                          <input
                            id="client-redirect"
                            type="text"
                            defaultValue={integration.oAuthPostAuthRedirectUri}
                            onChange={(e) => {this.handleInput('oAuthPostAuthRedirectUri', e)}}
                            required
                            aria-required="true"
                          />
                        </li>
                      }

                      {systemName === 'canvas' &&
                        <li>
                          <label className="lbl-required" htmlFor="client-logout">
                            {translation[systemName].logout_uri}
                          </label>

                          <input
                            id="client-logout"
                            type="text"
                            defaultValue={integration.oAuthLogoutUri}
                            onChange={(e) => {this.handleInput('oAuthLogoutUri', e)}}
                          />
                        </li>
                      }
                    </ul>
                  </div>
                </fieldset>

                <div className="panel__actions actions">
                  {
                    this.state.showAuthBtn &&
                    integration.systemName.toLowerCase() === 'desire2learn' &&
                    <a
                      href={`${config.ltiUrl}/v1/auth/d2l/${this.props.integrationSid}`}
                      className="actions__btn actions__btn--secondary"
                    >
                      {translation.authenticate}
                    </a>
                  }

                  {
                    this.state.showAuthBtn &&
                    integration.systemName.toLowerCase() === 'canvas' &&
                    <a
                      href={`${config.ltiUrl}/v1/oauth/${this.props.integrationSid}`}
                      className="actions__btn actions__btn--secondary"
                    >
                      {translation.authenticate}
                    </a>
                  }

                  <button
                    className="actions__btn actions__btn--primary"
                    type="submit"
                  >
                    {translation.save}
                  </button>
                </div>
              </div>
            </form>
          }
        </div>
      </div>
    )
  }
})

export default translate('OAuth')(OAuth);



// WEBPACK FOOTER //
// ./src/app/components/Integrations/OAuth.js